import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import "scorm-again/dist/scorm12.js";
import "scorm-again/dist/scorm2004.js";

const Scorm = (props: any) => {
const [directLink, setDirectLink] = useState<string>("");

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  let src = props.src || "";
  const height = props.height || "900px";
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!src) return;

        let targetUrl = src;
        if (src.includes("/open-api/cdn")) {
          const sep = src.includes("?") ? "&" : "?";
          targetUrl = `${src}${sep}redirect=false`;
        }

        const response = await axios.get(targetUrl);
        const rawLink =
          response?.data?.url ||
          response?.data?.data?.url ||
          response?.request?.responseURL;

        if (rawLink) {
          const url = new URL(rawLink);
          const modifiedPath = `/s3${url.pathname}`;
          setDirectLink(modifiedPath);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [src]);

  useEffect(() => {
    const iframe = iframeRef.current;

    if (iframe && directLink) {
      iframe.src = "about:blank";

      const onLoadHandler = () => {
        const iframeDocument =
          iframe.contentDocument || iframe.contentWindow?.document;

        if (iframeDocument) {
          const settings = { autocommit: true };

          // @ts-ignore - Create SCORM 1.2 API
          const api12 = new Scorm12API(settings);
          // @ts-ignore - Create SCORM 2004 API
          const api2004 = new Scorm2004API(settings);

          // Assign to window for SCORM content to find
          (window as any).API = api12; // SCORM 1.2
          (window as any).API_1484_11 = api2004; // SCORM 2004

          // Add LMS* method aliases for SCORM 1.2 compatibility
          if (!api12.LMSInitialize) api12.LMSInitialize = api12.Initialize;
          if (!api12.LMSFinish) api12.LMSFinish = api12.Terminate;
          if (!api12.LMSGetValue) api12.LMSGetValue = api12.GetValue;
          if (!api12.LMSSetValue) api12.LMSSetValue = api12.SetValue;
          if (!api12.LMSCommit) api12.LMSCommit = api12.Commit;
          if (!api12.LMSGetLastError)
            api12.LMSGetLastError = api12.GetLastError;
          if (!api12.LMSGetErrorString)
            api12.LMSGetErrorString = api12.GetErrorString;
          if (!api12.LMSGetDiagnostic)
            api12.LMSGetDiagnostic = api12.GetDiagnostic;

          iframe.src = directLink;
        }

        iframe.removeEventListener("load", onLoadHandler);
      };

      iframe.addEventListener("load", onLoadHandler);
    }
  }, [directLink]);

  return (
    <div ref={containerRef} style={{ position: "relative", width: "100%" }}>
      <iframe
        ref={iframeRef}
        src=""
        allow="fullscreen"
        scrolling="yes"
        width="100%"
        height={height}
        style={{
          border: "none",
          display: "block",
        }}
      />
      <br />
    </div>
  );
};

export default Scorm;